<div class="flex-wrapper">
  <span class="label">From:</span>
  <cm-datepicker
    class="datepicker"
    placeholder="From"
    [id]="id+'_from'"
    [ngModel]="value.from"
    (ngModelChange)="onValueChange({from: $event})"
    [disabled]="disabled"
    (blur)="onTouched($event)"
    [minDate]="minDate"
    [maxDate]="value.to || maxDate"
  >
  </cm-datepicker>
</div>
<div class="flex-wrapper">
  <span class="label">To:</span>
  <cm-datepicker
    class="datepicker"
    placeholder="To"
    [id]="id+'_to'"
    [ngModel]="value.to"
    (ngModelChange)="onValueChange({to: $event})"
    [disabled]="disabled"
    (blur)="onTouched($event)"
    [minDate]="value.from || minDate"
    [maxDate]="maxDate"
  >
  </cm-datepicker>
</div>
